/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Menu_Share_ProjectInputs */

const en_team_menu_share_project = /** @type {(inputs: Team_Menu_Share_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share Project`)
};

const fr_team_menu_share_project = /** @type {(inputs: Team_Menu_Share_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager le projet`)
};

const de_team_menu_share_project = /** @type {(inputs: Team_Menu_Share_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt teilen`)
};

const it_team_menu_share_project = /** @type {(inputs: Team_Menu_Share_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi progetto`)
};

const ru_team_menu_share_project = /** @type {(inputs: Team_Menu_Share_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совместный проект`)
};

const es_team_menu_share_project = /** @type {(inputs: Team_Menu_Share_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir proyecto`)
};

const zh_cn2_team_menu_share_project = /** @type {(inputs: Team_Menu_Share_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享项目`)
};

const ja_team_menu_share_project = /** @type {(inputs: Team_Menu_Share_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを共有`)
};

const hi_team_menu_share_project = /** @type {(inputs: Team_Menu_Share_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट साझा करें`)
};

const pt_pt2_team_menu_share_project = /** @type {(inputs: Team_Menu_Share_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar Projeto`)
};

/**
* | output |
* | --- |
* | "Share Project" |
*
* @param {Team_Menu_Share_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_menu_share_project = /** @type {((inputs?: Team_Menu_Share_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Menu_Share_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_menu_share_project(inputs)
	if (locale === "de") return de_team_menu_share_project(inputs)
	if (locale === "it") return it_team_menu_share_project(inputs)
	if (locale === "ru") return ru_team_menu_share_project(inputs)
	if (locale === "es") return es_team_menu_share_project(inputs)
	if (locale === "zh-CN") return zh_cn2_team_menu_share_project(inputs)
	if (locale === "ja") return ja_team_menu_share_project(inputs)
	if (locale === "hi") return hi_team_menu_share_project(inputs)
	if (locale === "pt-PT") return pt_pt2_team_menu_share_project(inputs)
	return en_team_menu_share_project(inputs)
});